import styled from "styled-components";

const NewTableStyles = styled.div`
  * {
    border-radius: 0 !important;
  }

  .ant-table-container {
    border-left: none !important;
  }
  .ant-table-cell:last-child {
    border-right: none !important;
  }

  .ant-table-body {
    max-height: 525px !important;
  }

  table {
    table-layout: fixed !important;
  }
`;

export default NewTableStyles;
